module.exports = __webpack_public_path__ + "img/huawuIcon1.f92973c2.png";